import { render, staticRenderFns } from "./ImpactOfDisabilityFilters.vue?vue&type=template&id=cf77069a&scoped=true"
import script from "./ImpactOfDisabilityFilters.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisabilityFilters.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisabilityFilters.vue?vue&type=style&index=0&id=cf77069a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf77069a",
  null
  
)

export default component.exports